import { NgModule } from '@angular/core';

import { WindowCloseComponent } from './window-close/window-close.component';
import { HelpersRoutingModule } from './helpers-routing.module';

@NgModule({
  declarations: [],
  imports: [HelpersRoutingModule, WindowCloseComponent]
})
export class HelpersModule {}
